import { Injectable } from '@angular/core';

import { AccountActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadRolesAndTeamsGuard  {

  constructor(private store$: Store<fromRoot.State>) { }

  canActivate(): Observable<boolean> {
    this.store$.dispatch(AccountActions.LoadUserRolesAndTeams());
    return this.store$.select(fromRoot.getUserRolesAndTeamsLoaded).pipe(
      first(loaded => !!loaded)
    );
  }
}
